import { Fragment } from 'react';

import Views from '../OrgUnitAdminUserViews';
import ViewTemplate from '../../../../components/viewTemplateOmeTeamEntry/ViewTemplate';

import OrgUnitAdminRelayEntriesWrite from './OrgUnitAdminRelayEntriesWrite';
import OrgUnitAdminRelayEntriesReadOnly from './OrgUnitAdminRelayEntriesReadOnly';

import useOrgUnitAdminRelayEntries from './UseOrgUnitAdminRelayEntries';

const OrgUnitAdminRelayEntries = () => {
  const { oUAdminEntryContextState, onNextButtonClicked, onSaveAndExitButtonClicked, onBackButtonClicked } = useOrgUnitAdminRelayEntries();

  return (
    <Fragment>
      <ViewTemplate
        viewName={Views.OME_MEET_RELAY_ENTRIES}
        onNextButtonClicked={onNextButtonClicked}
        onSaveAndExitButtonClicked={onSaveAndExitButtonClicked}
        onBackButtonClicked={onBackButtonClicked}>
        {oUAdminEntryContextState.isReadOnly === false ?
          <OrgUnitAdminRelayEntriesWrite /> :
          <OrgUnitAdminRelayEntriesReadOnly />
        }
      </ViewTemplate>
    </Fragment>
  );
};

export default OrgUnitAdminRelayEntries;